import React, { useEffect, useState } from 'react';
import { _setAxios } from '../../../lib/Helper';
import { Autocomplete, TextField } from '@mui/material';
import { Skeleton } from 'antd';

async function fetchList() {

  return await _setAxios("setting/dropdown/modul/36")
    .then(body => {
      let results = []
      body.data?.data?.forEach(row => {
        results.push({
          label: row.list,
          value: row.id,
        })
      });

      return results
    })
}

const SelectPenggunaanRuangan = ({ ...props }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchList().then((newOptions) => {
      setOptions(newOptions);
    });
  }, []);

  if (!options.length) return <Skeleton.Button active block />

  return (
    <Autocomplete
      {...props}
      options={options}
      value={options.find(option => option.value === props.value)}
      noOptionsText="Tidak ada data"
      renderInput={(params) => <TextField {...params}
        fullWidth
        label="Penggunaan Ruangan"
        size="small"
        InputLabelProps={{
          shrink: true,
        }}
        name="penggunaan"
        type="text"
        helperText={
          props.errors?.penggunaan ? props.errors?.penggunaan[0] : null
        }
        error={
          props.errors?.penggunaan
        }
      />}
    />
  );
};
export default SelectPenggunaanRuangan;
